var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wholePage"},[_c('a-card',{attrs:{"title":"工单创建时间散点图","size":"small"}},[_c('div',{style:({ height: _vm.height, width: _vm.width }),attrs:{"id":"ticket-create-time"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }